import React from 'react';
import styled from 'styled-components';
import PrimaryButton from './PrimaryButton';
import logo from '../img/logo.svg';
import { Fade } from 'react-reveal';

function Navigation() {
    return ( 
        <Fade top >
            <NavigationStyled >
                <div className = "logo" >
                    <img src = { logo } alt = "" />
                </div> 
                <ul>
                    <li ><a href = "" > Home </a> </li > 
                    <li > <a href = "" > Features </a> </li > 
                    <li > <a href = "" > Pricing </a> </li > 
                </ul> 
            <PrimaryButton name = { 'Sign Up' }/> 
        </NavigationStyled > 
    </Fade>
    )
}


const NavigationStyled = styled.nav `
    padding-top: 1rem;
    display: flex;
    justify-content: space-between;
    min-height: 10vh;
    align-items: center;

    ul{
        display: flex;
        justify-content: center;
        width: 40%;
        @media screen and (max-width: 786px){
            display: none;
        }
    }
    li {
        padding: 0 2rem;
    }
`;
export default Navigation